module.exports = "\n.container {\n    padding: 10px;\n}\n\n.risposta {\n    margin-top: 20px;\n}\n\n.risposta span {\n    font-weight: bold;\n}\n\n.bottom {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: reverse;\n        -ms-flex-direction: row-reverse;\n            flex-direction: row-reverse;\n    padding: 15px 0;\n}\n\n.card-body {\n    padding: 10px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/opzioni/domande-risposte-appuntamento/domande-risposte-appuntamento.css
// module id = ./src/app/opzioni/domande-risposte-appuntamento/domande-risposte-appuntamento.css
// module chunks = main